export default function BidListViewIcon({ isListView, setIsListView }: any) {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="button"
      tabIndex={0}
      onClick={() => setIsListView(true)}
      onKeyDown={(e: any) => e.key === 'Enter' && setIsListView(true)}
    >
      <rect
        x="0.5"
        y="0.5"
        width="20"
        height="7"
        fill={isListView ? '#297AF7' : '#28282E'}
      />
      <rect
        x="0.5"
        y="9.5"
        width="20"
        height="7"
        fill={isListView ? '#297AF7' : '#28282E'}
      />
    </svg>
  )
}
